import Vue from 'vue'

const DownloadInstance = Vue.extend(require('./download.vue').default);
let instance = null
let confirmPromise = null
let confirmResolve = null
let canUse = true

let getInstance = () => {
  return new DownloadInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  if(instance){
    instance.close()
    instance.$el.parentNode.removeChild(instance.$el);
    instance = null
    if (confirmResolve) {
      confirmResolve(false)
      confirmResolve = null
    }
    confirmPromise = null
  }
}

let DownloadMessage = (config) => {
  if (instance) {
    if(config == 'unload'){
      close()
      canUse = false;
    }else{
      canUse = false;
      confirmResolve(false)
    }
  }else{
    if(config == 'unload'){
      close()
      canUse = false;
    }else{
      canUse = true;
    }
  }

  if(canUse) {
    instance = getInstance()

    document.body.appendChild(instance.$el);
    confirmPromise = new Promise((resolve, reject) => {
      confirmResolve = resolve
    })
    instance.open(config, confirmResolve)
  }

  return confirmPromise
}

export default DownloadMessage
